import { User } from '../models/user';

export class UpdateUser {
    static readonly type = '[User] UpdateUser';

    constructor(public payload: User) {}
}
